import { render, staticRenderFns } from "./MatrixContent.vue?vue&type=template&id=72ce52da"
import script from "./MatrixContent.vue?vue&type=script&lang=ts"
export * from "./MatrixContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports